import { message, Spin } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { useDispatch, useSelector } from "react-redux";
import { userLoaded } from "../../redux/actions";
import NavMenuItem from "./nav-menu-item";
import "./nav-menu.css";

const NavMenu = () => {
  const d = useDispatch();
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const user = useSelector((s) => s.user);

  useEffect(() => {
    user && checkSession();
  }, [user]);
  
  const checkSession = () => {
    serverFetch("auth/CheckSession")
      .then(data => {
        if (data.support !== user.support) {
          d(userLoaded(data));
          // Обновляем компонент, чтобы изменения в user.support отразились в меню
          window.location.reload();
        }
      })
      .catch(e => {
        if (e.statusCode === 500) d(userLoaded(null));
      })
  }

  const onLogout = () => {
    setLoading(true);
    serverFetch("auth/logout", { method: "POST" })
      .then(() => {
        setLoading(false);
        d(userLoaded(null));
      })
      .catch(e => {
        setLoading(false);
        d(userLoaded(null));
        message.error(e.userMessage);
      })
  }

  // const support = session?.support ?? true;
  // console.log(user);
  
  useEffect(() => {
    const newItem = [
      getItem('Компания', 'company', '/', 'home.svg'),
      getItem('Заказы', 'orders', '/orders', 'order.svg'),
      getItem('Задачи', 'tasks', '/tasks', user.support ? 'calendar.svg' : 'calendar-block.svg', null, user.support ? false : true),
      getItem('Пакеты', 'packets', '/packets', 'pack.svg'),
    ];
    user?.admin && newItem.push(getItem('Компании', 'companies', '/companies', 'admin.svg'));
    newItem.push(getItem('Лицензии', 'licenses', '/licenses', 'license.svg'));
    newItem.push(getItem('Сообщения', 'messages', '/messages', 'mail-b.svg'));
    newItem.push(getItem('Поддержка', 'support', '/support', 'support.svg'));
    user?.admin && newItem.push(getItem('Настройки', 'settings', '/settings', 'settings.svg'));
    newItem.push(getItem('Выход', 'logout', '', 'exit.svg', onLogout));
    setItems(newItem);
  }, [])

  const getItem = (label, key, urlTo, img, onClick, disabled = false)  => ({ key, label, url: urlTo, img, onClick, disabled });

  return loading ? <Spin /> : <div className='nav-menu-container'>
      <div className='sider-logo-new'><a href='/'><img src="/images/logo.svg" alt="logo"/></a></div>
      {items.map(i => <NavMenuItem {...i} key={i.key} />)}
      <div className='nav-menu-footer'>{process.env.REACT_APP_VERSION}</div>
    </div>
}

export default NavMenu;